import styled from 'styled-components';

export const UserPointContainerStyled = styled.div`
  .filter_layout {
    margin-bottom: 1rem;
  }
`;
